export const STEER_WIDTH_MIN_RATIO = 0.8;
export const STEER_WIDTH_MAX_RATIO = 1;

const SMOOTHING = 0.18;

export function readViewportWidth(): number {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.visualViewport?.width ?? window.innerWidth;
}

export function getSteerWidthRange(baselineWidth: number) {
  return {
    min: baselineWidth * STEER_WIDTH_MIN_RATIO,
    max: baselineWidth * STEER_WIDTH_MAX_RATIO,
  };
}

export function mapViewportWidthToSteer(
  width: number,
  baselineWidth: number,
): number {
  const { min, max } = getSteerWidthRange(baselineWidth);
  const span = max - min;
  if (span <= 0) {
    return 0.5;
  }

  const clamped = Math.min(max, Math.max(min, width));
  const normalized = (clamped - min) / span;

  return 1 - normalized;
}

export function smoothSteerTarget(
  previous: number | null,
  width: number,
  baselineWidth: number,
): number {
  const target = mapViewportWidthToSteer(width, baselineWidth);
  const base = previous ?? target;
  return base + (target - base) * SMOOTHING;
}

export function getNormalizedSteerPercent(
  width: number,
  baselineWidth: number,
): number {
  const { min, max } = getSteerWidthRange(baselineWidth);
  const span = max - min;
  if (span <= 0) {
    return 100;
  }

  const clamped = Math.min(max, Math.max(min, width));
  const normalized = (clamped - min) / span;

  return Math.round(normalized * 100);
}
